import { createTheme } from "@mui/material";

export const theme = createTheme({
  typography: {
    fontFamily: [
      "Geist",
      "Arial",
      "--aple-system",
      "system-ui"
    ].join(","),
    h1: {
      fontSize: 40,
      fontWeight: 600
    },
    h2: {
      fontSize: 32,
      fontWeight: 600
    },
    h3: {
      fontSize: 28,
      fontWeight: 600
    },
    h4: {
      fontSize: 24,
      fontWeight: 600
    },
    h5: {
      fontSize: 20,
      fontWeight: 600
    },
    h6: {
      fontSize: 16,
      fontWeight: 600
    }
  }
})
